import Plan from "../types/Plan";
import Product from "../types/Product";

export default (item: Product | Plan): item is Plan =>
  item.hasOwnProperty("products");
